
<form #formElem [formGroup]="form" class="form layout-col gap-24">
  <div class="f-section" *ngIf="mode === 'insert'">
    <div class="f-section-title">
      <span>1) Selezione esami</span>
    </div>

    <div class="f-section-content">
      <p class="description">
        Scegli dalla lista di esami predefiniti gli esami che il paziente dovrà sostenere
      </p>

      
      <div class="f-entry layout-row">
        <div class="f-entry-title flex-20 flex-100-md">
          <span>Esami</span>
        </div>

        <div class="f-entry-content flex-80 flex-100-md">
          <p>
            <i>Scegli <b>uno o più</b> esami da prescrivere</i>
          </p>

          <c3-message type="info" *ngIf="defaultExaminationsFiltered?.length === 0">
            <p>Non sono presenti esami prescrivibili a questo tipo di paziente.</p>
          </c3-message>

          
          <mat-selection-list (selectionChange)="toggleExamControlFromList($event)">
            <mat-list-option
              *ngFor="let exam of defaultExaminationsFiltered; let i = index"
              checkboxPosition="before"
              [value]="exam"
              [selected]="isExaminationSelected(exam.name)"
              style="height: 100%"
            >
              <div style="height: 100%; padding: 12px 0">
                <span>
                  <span>{{ exam.name }}</span>
                  <span *ngIf="exam.frequency">
                    <span>&nbsp;(ogni </span>
                    <b>{{ exam.frequency?.value }}&nbsp;</b>
                    <ng-container [ngSwitch]="exam.frequency?.unit">
                      <b *ngSwitchCase="'day'">giorni</b>
                      <b *ngSwitchCase="'week'">settmane</b>
                      <b *ngSwitchCase="'month'">mesi</b>
                      <b *ngSwitchCase="'year'">anni</b>
                    </ng-container>
                    <span>)</span>
                  </span>
                </span>
                <div *ngIf="exam.subExams?.length > 0">
                  <small>
                    <p style="margin: 0">Include i seguenti esami:</p>
                    <ul style="margin: 0">
                      <li *ngFor="let subExam of exam.subExams">
                        {{ subExam }}
                      </li>
                    </ul>
                  </small>
                </div>
              </div>
            </mat-list-option>
          </mat-selection-list>

          
          
        </div>
      </div>
    </div>
  </div>

  <div class="f-section">
    <div class="f-section-title">
      <span *ngIf="mode === 'insert'">2) Specifiche esami</span>
      <span *ngIf="mode !== 'insert'">Esame</span>
    </div>

    <div class="f-section-content">
      <p *ngIf="mode === 'insert'" class="description">
        Una volta selezionati gli esami per il paziente, completa la loro prescrizione inserendo
        data di inizio, frequenza e tipologia di notifica.
      </p>

      <ul formArrayName="exams">
        <li class="layout-col" *ngFor="let e of formExamsArrayControl.controls; let i = index">
          <div [formGroupName]="i">
            <div class="f-section-title">
              <ion-item-divider>
                <div
                  class="c3-flex c3-full-width ion-align-items-center ion-justify-content-between"
                >
                  <span style="font-size: 16px; color: var(--ion-color-light-contrast)">{{
                    e.value?.title
                  }}</span>
                  <ion-buttons>
                    <ion-button
                      *ngIf="mode === 'insert'"
                      (click)="removeExamControl(i)"
                      color="danger"
                      c3Tooltip="Rimuovi dalla lista"
                    >
                      <ion-icon slot="icon-only" [src]="'delete' | getIcon"></ion-icon>
                    </ion-button>
                  </ion-buttons>
                </div>
              </ion-item-divider>
            </div>

            <div class="layout-row layout-wrap layout-align-start-center gap-6">
              <div class="f-section">
                <div class="f-section-content">
                  
                  

                  
                  <div class="f-entry layout-row">
                    <div class="f-entry-title flex-20 flex-100-md">
                      <span>Data dell'esame</span>
                    </div>
                    <div class="f-entry-content flex-80 flex-100-md">
                      <p>
                        <i>Definisci la prima volta che l'esame dovrà essere effettuato</i>
                      </p>
                      <mat-form-field compact>
                        <input
                          matInput
                          formControlName="startDate"
                          [min]="tomorrow"
                          [matDatepicker]="startDatePicker"
                          placeholder="Data d'inizio"
                          required
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="startDatePicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  
                  <div class="f-entry layout-row">
                    <div class="f-entry-title flex-20 flex-100-md">
                      <span>Periodicità</span>
                    </div>
                    <div class="f-entry-content flex-80 flex-100-md">
                      <p>
                        <i>Definisci se l'esame dovrà essere ripetuto nel tempo</i>
                      </p>

                      <mat-radio-group formControlName="frequencyType" class="layout-col gap-6">
                        <mat-radio-button value="at_need">Esame singolo</mat-radio-button>
                        <mat-radio-button value="every_x_days">Esame periodico</mat-radio-button>
                      </mat-radio-group>

                      <div
                        *ngIf="e.value?.frequencyType === 'every_x_days'"
                        class="layout-row layout-align-start-center gap-6"
                      >
                        <span>L'esame dovrà essere ripetuto ogni</span>
                        <mat-form-field compact>
                          <input matInput formControlName="frequencyValue" type="number" min="1" />
                        </mat-form-field>

                        <mat-form-field compact>
                          <mat-select
                            placeholder="Unità di tempo"
                            formControlName="frequencyUnit"
                            required
                          >
                            <mat-option *ngFor="let item of EXAM_PERIODIC_UNIT" [value]="item.key">
                              {{ item.label }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  
                  <div class="f-entry layout-row" *ngIf="e.value?.frequencyType === 'every_x_days'">
                    <div class="f-entry-title flex-20 flex-100-md">
                      <span>Termine periodicità</span>
                    </div>
                    <div class="f-entry-content flex-80 flex-100-md">
                      <p>
                        <i>Definisci fino a quando l'esame dovrà essere ripetuto</i>
                      </p>
                      <mat-form-field compact>
                        <input
                          matInput
                          formControlName="endDate"
                          [min]="tomorrow"
                          [matDatepicker]="endDatePicker"
                          placeholder="Data di termine"
                          readonly
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="endDatePicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  
                  <div class="f-entry layout-row">
                    <div class="f-entry-title flex-20 flex-100-md">
                      <span>Notifica</span>
                    </div>
                    <div class="f-entry-content flex-80 flex-100-md" formGroupName="alarm">
                      <p>
                        <i>Definisci come e quando notificare l'esame al paziente</i>
                      </p>

                      
                      <div class="f-entry layout-row">
                        <div class="f-entry-title flex-20 flex-100-md">
                          <span>Tipo di notifica</span>
                        </div>
                        <div class="f-entry-content flex-80 flex-100-md">
                          <mat-form-field compact>
                            <mat-select
                              placeholder="Tipo di notifica"
                              formControlName="type"
                              required
                              #alarmType
                            >
                              <mat-option *ngFor="let item of ALARM_TYPE" [value]="item.key">
                                {{ item.label }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <ng-container *ngIf="alarmType.value !== 'none'">
                        
                        <div class="f-entry layout-row">
                          <div class="f-entry-title flex-20 flex-100-md">
                            <span>Anticipazione</span>
                          </div>
                          <div class="f-entry-content flex-80 flex-100-md">
                            <p>
                              <i>Definisci quanto prima al paziente verrà notificato l'esame</i>
                            </p>

                            <div class="layout-row layout-wrap layout-align-start-center gap-6">
                              <span>Notifica l'esame</span>

                              <mat-form-field compact>
                                <input
                                  matInput
                                  type="number"
                                  min="0"
                                  formControlName="anticipation_value"
                                  required
                                />
                              </mat-form-field>

                              <mat-form-field compact>
                                <mat-select
                                  placeholder="Unità di tempo"
                                  formControlName="anticipation_unit"
                                  required
                                >
                                  <mat-option
                                    *ngFor="let item of ALARM_ANTICIPATION_UNIT"
                                    [value]="item.key"
                                  >
                                    {{ item.label }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                              <span>prima.</span>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>

                  
                  <ng-container
                    *ngIf="findDefaultExamination(e.value?.title); let defaultExamination"
                  >
                    <div
                      class="f-entry layout-row"
                      *ngIf="defaultExamination.subExams; let subExamsList"
                    >
                      <div class="f-entry-title flex-20 flex-100-md">
                        <span>Esami inclusi</span>
                      </div>
                      <div class="f-entry-content flex-80 flex-100-md">
                        <p>
                          <i>Specifica quali esami includere nel pacchetto di esami</i>
                        </p>

                        <mat-selection-list formControlName="subExams">
                          <mat-list-option
                            *ngFor="let subExam of subExamsList"
                            [value]="subExam"
                            checkboxPosition="before"
                          >
                            {{ subExam }}
                          </mat-list-option>
                        </mat-selection-list>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>

      <div *ngIf="mode === 'insert'">
        <p>
          Puoi aggiungere eventuali esami personalizzati (oltre a quelli predefiniti) inserendo il
          nome nel campo sottostante:
        </p>
        <div class="c3-flex c3-full-width">
          <ion-item class="ion-margin-end" style="flex: 1">
            <ion-input placeholder="Nome esame" [formControl]="customExamName"></ion-input>
          </ion-item>

          <ion-button (click)="onAddCustomExam()">
            Aggiungi esame personalizzato alla lista
          </ion-button>
        </div>
      </div>
    </div>
  </div>

  
  
</form>
